import React, { type FC } from "react";
import { useTrackElement } from "@edreamsodigeo/frontend-core";
import { Flex, Link } from "@edreamsodigeo/prisma-design-system";

import { type FormLinkProps } from "./contract";

const FormLink: FC<FormLinkProps> = ({
  children,
  onClick,
  trackingId = "",
  withTextDecoration = false,
  sx = {},
  size = "xSmall",
}) => {
  const clickTrackingRef = useTrackElement<HTMLAnchorElement>(
    ["click"],
    trackingId,
  );

  return (
    <Flex>
      <Link
        {...(trackingId && { ref: clickTrackingRef })}
        size={size}
        variant="inline"
        sx={{
          ...sx,
          ...(!withTextDecoration && {
            textDecoration: "none",
          }),
        }}
        onClick={onClick}
      >
        {children}
      </Link>
    </Flex>
  );
};

export default FormLink;
